<ds-tile
  class="billing-tile"
  [variant]="billAccountCard.metadata.pillVariant"
  [showPill]="billAccountCard.metadata.pillText ? true : false"
>
  <span tile-pill data-cy="billAccountCardPillText">{{ billAccountCard.metadata.pillText }}</span>
  <div class="tile-heading" tile-heading data-cy="billAccountCardAlert">
    <div class="heading-text">
      <div class="row" data-cy="billAccountMinimumDuePastDue">
        <div class="column col-md-six">
          <span class="tile-title">
            @if (!billAccountCard.metadata.isPastDue) {
              {{ billAccountCard.metadata.minimumDue | currencyUSD }}
            }
            <!--Past Due Minimum Due-->
            @if (billAccountCard.metadata.minimumDue > 0 && billAccountCard.metadata.isPastDue) {
              {{
                !billAccountCard.metadata.cancelLetterSent &&
                !!billAccountCard.metadata.previousAmountDue
                  ? (billAccountCard.metadata.previousAmountDue | currencyUSD)
                  : (billAccountCard.metadata.minimumDue | currencyUSD)
              }}
            }
          </span>
        </div>
        <div class="column col-md-six float-right" data-cy="minimumDueDate">
          <!--  @if(billAccountCard.metadata.minimumDue > 0 &&
        billAccountCard.metadata.minimumDueDate &&
        billAccountCard.metadata.minimumDueDate !== '0001-01-01T00:00:00.0-0600'){ -->
          @if (billAccountCard.status.statusPillText) {
            <span
              class="tile-status-pill float-right"
              [ngClass]="billAccountCard.status.statusPillType"
            >
              {{ billAccountCard.status.statusPillText }}
            </span>
          } @else {
            <span
              class="tile-status-pill float-right"
              [ngClass]="
                billAccountCard.status.statusPillType === 'error-pill'
                  ? 'error-pill'
                  : 'warning-pill'
              "
            >
              Due {{ billAccountCard.metadata.minimumDueDate | dateFormat: 'MMM D' }}
            </span>
          }
          <!-- } -->
        </div>
      </div>

      <!--Risks-->
      <div class="row twelve risk-description" data-cy="billAccountRiskDescriptions">
        @if (billAccountCard.metadata.riskDescriptions.length > 0) {
          @for (
            riskDescription of billAccountCard.metadata.riskDescriptions;
            track riskDescription
          ) {
            <p class="">
              {{ riskDescription }}
            </p>
          }
        }
        @if (
          billAccountCard.metadata.riskDescriptions.length <= 0 &&
          billAccountCard.icon === 'icon-linked-thick'
        ) {
          <p dsContent [contentPath]="'billing.linkedAccount'"></p>
        }
      </div>
      <!--Last Payment Date-->
      <!-- <p
    class="heading-text-last-payment"
    *ngIf="billAccountCard.metadata.lastPaymentDate"
    data-cy="billingCardLastPaymentDate"
    >
    Last payment: {{ billAccountCard.metadata.lastPaymentDate | dateFormat: 'MM/DD/YYYY' }}
  </p> -->
    </div>
    <!--Status Text-->
    @if (billAccountCard.status.statusText) {
      <div
        class="tile-content"
        aria-hidden="true"
        [ngClass]="billAccountCard.status.statusIcon + '-container'"
        tile-content
        data-cy="billAccountCardStatusIcon"
      >
        <div class="flex">
          <span
            [ngClass]="billAccountCard.status.statusIcon"
            data-cy="billAccountStatusIcon"
          ></span>
          <span
            data-cy="billAccountStatusText"
            [ngClass]="{ primaryIconFont: billAccountCard.status.statusIcon === 'icon-info' }"
            >{{ billAccountCard.status.statusText }}</span
          >
        </div>
      </div>
    }
  </div>

  <div tile-cta class="tile-cta">
    <!--Action Button-->
    @if (billAccountCard.status.actionButton) {
      <button
        ds-button
        [ngClass]="
          billAccountCard.status.statusIcon === 'icon-alert'
            ? '-primary'
            : billAccountCard.status.paymentNeeded &&
                billAccountCard.metadata.minimumDue > 0 &&
                billAccountCard.metadata.scheduledPayments[0]?.paymentStatus !== 'AUTHORIZED'
              ? '-primary'
              : '-outline-white'
        "
        class="margin-right-8"
        (click)="actionButtonEvent.emit(billAccountCard)"
        [attr.aria-label]="billAccountCard.status.actionButton"
        data-cy="billingOverviewActionButton"
      >
        {{ billAccountCard.status.actionButton }}
      </button>
    }
    <!--Manage Bill Button-->
    <button
      ds-button
      class="link"
      [ngClass]="{ 'margin-left-8': !!billAccountCard.status.actionButton }"
      (click)="viewAccountEvent.emit(billAccountCard)"
      [attr.aria-label]="'Bill details'"
      data-cy="billingOverviewAccountButton"
      dsContent
      [contentPath]="'billing.billDetails'"
    ></button>
  </div>
</ds-tile>
